module.exports = __webpack_public_path__ + "img/vertical_3_4_1.109c25ad.png";